import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ToastProvider } from './components/ui';
import { AuthProvider } from './lib/auth';
import { I18nProvider, useI18n } from './lib/i18n';
import { bootTheme, syncTheme } from './lib/theme';
import { bootMode } from './lib/mode';
import './styles/global.css';

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root não encontrado.');

bootTheme();
bootMode();

// Trocar o idioma remonta a árvore para que todo texto e valor seja recalculado.
function LocalizedApp(): JSX.Element {
  const { locale } = useI18n();
  return <App key={locale} />;
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <I18nProvider>
        <ToastProvider>
          <AuthProvider>
            <LocalizedApp />
          </AuthProvider>
        </ToastProvider>
      </I18nProvider>
    </BrowserRouter>
  </StrictMode>
);

// O tema é global (Administração › Configurações); confirma com a API depois de pintar.
void syncTheme();

// Só no build publicado: em desenvolvimento o service worker escondia o código novo atrás de cache.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* sem service worker o app segue funcionando pela rede */
    });
  });
}
